const FilterBar = {
  parts: [
    'container',
    'filtersWrapper',
    'quickFilters',
    'showFiltersButton',
    'tuneIcon',
    'showFiltersText',
    'filterChips',
    'chip',
    'chipText',
    'resultsColumn',
    'resultsText'
  ],
  baseStyle: {
    container: {
      display: 'flex',
      pb: {base: 4, md: 6},
      flexDirection: {base: 'column', md: 'row'},
      alignItems: {base: 'flex-start', md: 'center'},
      justifyContent: {base: 'flex-start', md: 'space-between'},
      gap: {base: 4, md: '109.75px'},
      alignSelf: 'stretch',
      position: 'relative',
    },

    filtersWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      alignSelf: 'stretch',
      position: 'relative',
    },

    quickFilters: {
      display: 'flex',
      alignItems: 'center',
      gap: {base: 3, md: 3},
      position: 'relative',
      flexWrap: 'wrap',
    },

    showFiltersButton: {
      display: 'flex',
      px: 4,
      py: 2,
      justifyContent: 'center',
      alignItems: 'center',
      gap: 2,
      borderRadius: '100px',
      bg: 'brandColors.greyscale90',
      position: 'relative',
      h: '35px',
      _hover: {
        bg: 'brandColors.greyscale80',
      },
      _active: {
        bg: 'brandColors.greyscale',
      },
      _focusVisible: {
        outline: '2px solid',
        outlineColor: 'brandColors.primaryDarkLinen',
        outlineOffset: '2px',
      },
    },

    tuneIcon: {
      w: 4,
      h: 4,
      color: 'white',
    },

    showFiltersText: {
      color: 'white',
      textAlign: 'center',
      fontFamily: 'heading',
      fontSize: 'md',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '120%',
      whiteSpace: 'nowrap',
    },

    filterChips: {
      display: 'flex',
      alignItems: 'center',
      gap: {base: 2, md: 4},
      position: 'relative',
      flexWrap: 'wrap',
    },

    chip: {
      display: 'flex',
      px: 4,
      py: 2,
      h: '35px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 2.5,
      borderRadius: '50px',
      border: '1px solid',
      borderColor: 'brandColors.linen03',
      bg: 'transparent',
      position: 'relative',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      _hover: {
        bg: 'brandColors.greyscale90',
        borderColor: 'brandColors.greyscale90',
      },
      _focusVisible: {
        outline: '2px solid',
        outlineColor: 'brandColors.primaryDarkLinen',
        outlineOffset: '2px',
      },
      sx: {
        '&:hover > p': {
          color: 'white',
        },
        '&[data-active="true"]': {
          bg: 'brandColors.greyscale90 !important',
          borderColor: 'brandColors.greyscale90 !important',
        },
        '&[data-active="true"] > p': {
          color: 'white !important',
        },
      },
    },

    chipText: {
      color: 'brandColors.greyscale90',
      fontFamily: 'heading',
      fontSize: 'md',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '120%',
      whiteSpace: 'nowrap',
      sx: {
        '[data-active="true"] &': {
          color: 'white !important',
        },
      },
    },

    resultsColumn: {
      display: 'flex',
      alignItems: 'center',
      gap: {base: 4, md: '27px'},
      position: 'relative',
    },

    resultsText: {
      color: 'brandColors.greyscale90',
      fontFamily: 'heading',
      fontSize: 'sm', // 14px
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '120%',
      whiteSpace: 'nowrap',
      flex: '0 0 150px',
    },
  },
};

export default FilterBar;
